<template>
    <ion-row class="c-dokbox-cards">
        <template v-for="(fileGroup, index) in filteredFileGroups">
            <ion-col
                size="12"
                :key="'date-' + index"
                v-if="getMonthLabel(index) !== ''"
            >
                <div class="c-chip u-m-bottom-small">
                    {{ getMonthLabel(index) }}
                </div>
            </ion-col>
            <ion-col size="12" size-md="6" :key="'card-' + index">
                <ion-card
                    class="c-dokbox-card"
                    @click="
                        openDokboxModal(
                            fileGroup.index,
                            fileGroup.categoryId,
                            baseurl + fileGroup.files[0].fileDownloadUrl
                        )
                    "
                    button
                    v-if="getCategoryName(fileGroup.categoryId) != 'skeleton'"
                >
                    <ion-row>
                        <ion-col size="8" class="c-dokbox-card__text">
                            <b>{{ fileGroup.name }}</b>
                            <div v-html="fileGroup.description"></div>
                            <div>{{ formatDate(fileGroup.date) }}</div>
                            <div class="c-dokbox-card__footer">
                                <ion-row>
                                    <ion-col size="auto">
                                        <span class="icon-dokument"></span>
                                        {{ fileGroup.files.length }}
                                    </ion-col>
                                    <ion-col class="c-dokbox-card__folder">
                                        <span class="icon-ordner"></span>
                                        {{
                                            getCategoryName(
                                                fileGroup.categoryId
                                            )
                                        }}
                                    </ion-col>
                                </ion-row>
                            </div>
                        </ion-col>
                        <ion-col
                            size="4"
                            class="c-dokbox-card__pdf hydrated"
                            v-if="fileGroup.files[0].fileType === 'pdf'"
                        >
                        </ion-col>
                        <ion-col
                            size="4"
                            class="ion-no-padding ion-text-center hydrated"
                            v-else
                        >
                            <div
                                class="c-dokbox-card__image"
                                :style="{
                                    backgroundImage:
                                        'url(' +
                                        $store.state.dokbox.base64Images[
                                            fileGroup.files[0].fileHash
                                        ] +
                                        ')',
                                }"
                            >
                                <ion-spinner
                                    class="c-dokbox-card__spinner"
                                    v-if="
                                        !$store.state.dokbox.base64Images[
                                            fileGroup.files[0].fileHash
                                        ]
                                    "
                                ></ion-spinner>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-card>

                <ion-card v-else class="c-dokbox-card">
                    <ion-row>
                        <ion-col size="8" class="c-dokbox-card__text">
                            <ion-skeleton-text
                                animated
                                style="width: 60%;"
                            ></ion-skeleton-text>
                            <ion-skeleton-text
                                animated
                                style="width: 30%;"
                            ></ion-skeleton-text>
                            <ion-skeleton-text
                                animated
                                style="width: 40%;"
                            ></ion-skeleton-text>
                            <div class="c-dokbox-card__footer">
                                <ion-row>
                                    <ion-col size="2">
                                        <ion-skeleton-text
                                            animated
                                            style="width: 20px;"
                                        ></ion-skeleton-text>
                                    </ion-col>
                                    <ion-col class="c-dokbox-card__folder">
                                        <ion-skeleton-text
                                            animated
                                            style="width: 150px;"
                                        ></ion-skeleton-text>
                                    </ion-col>
                                </ion-row>
                            </div>
                        </ion-col>
                        <ion-col
                            size="4"
                            class="c-dokbox-card__image ion-no-padding"
                        >
                            <ion-skeleton-text
                                animated
                                style="width: 100%; height: 100%; margin: 0;"
                            ></ion-skeleton-text>
                        </ion-col>
                    </ion-row>
                </ion-card>
            </ion-col>
        </template>
    </ion-row>
</template>

<script>
import { BASEURL } from "@/utils/globals";
import DokboxModal from "@/components/DokboxModal";
import { DateFormatter } from "@/utils/date";
import { file } from "@/mixins/file";

export default {
    mixins: [file],
    components: {},
    props: {
        token: {
            type: String,
            required: true,
        },
        limitCategories: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        limitYears: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            baseurl: BASEURL,
            api_static: process.env.VUE_APP_API_STATIC,
        };
    },
    computed: {
        filteredFileGroups() {
            let result = [];
            for (let [index, fileGroup] of this.$store.getters[
                "dokbox/fileGroups"
            ].entries()) {
                let year = fileGroup.date.substring(0, 4);
                if (
                    fileGroup.categoryId !== 99 ||
                    (this.limitCategories.length === 0 &&
                        this.limitYears.length === 0) ||
                    (this.limitCategories.length === 0 &&
                        this.limitYears.includes(year)) ||
                    (this.limitYears.length === 0 &&
                        this.limitCategories.includes("99")) ||
                    (this.limitCategories.includes("99") &&
                        this.limitYears.includes(year))
                ) {
                    fileGroup.index = index;
                    result.push(fileGroup);
                }
            }
            if (result.length > 0) {
                this.$emit("is-empty", false);
            } else {
                this.$emit("is-empty", true);
            }
            return result;
        },
    },
    methods: {
        getMonthLabel(fileGroupIndex) {
            let result = "";
            if (
                this.filteredFileGroups[fileGroupIndex] &&
                (fileGroupIndex === 0 ||
                    this.filteredFileGroups[fileGroupIndex - 1].date.substring(
                        0,
                        7
                    ) !==
                        this.filteredFileGroups[fileGroupIndex].date.substring(
                            0,
                            7
                        ))
            ) {
                result = DateFormatter.formatDate(
                    new Date(this.filteredFileGroups[fileGroupIndex].date),
                    "MMMM YYYY"
                );
            }
            return result;
        },
        getCategoryName(id) {
            let result = "";
            if (
                id in this.$store.getters["dokbox/categories"] &&
                "name" in this.$store.getters["dokbox/categories"][id]
            ) {
                result = this.$store.getters["dokbox/categories"][id].name;
            }
            return result;
        },
        openDokboxModal(fileGroupIndex, categoryId, url) {
            if (categoryId === 99) {
                this.downloadFile(url);
            } else {
                this.$ionic.modalController
                    .create({
                        component: DokboxModal,
                        componentProps: {
                            propsData: {
                                fileGroupIndex: fileGroupIndex,
                            },
                            parent: this,
                        },
                        backdropDismiss: false,
                    })
                    .then((m) => m.present());
            }
        },
        formatDate(date) {
            return DateFormatter.formatDate(new Date(date), "DD. MMMM YYYY");
        },
    },
};
</script>

<style lang="scss" scoped>
.c-dokbox-card {
    border: solid 1px var(--ion-color-medium);
    padding: 0;
    height: 150px;
    &__text {
        padding: var(--gangl-padding-medium);
        padding-bottom: var(--gangl-padding-xxlarge);
        line-height: 1.4;
    }
    &__footer {
        position: absolute;
        bottom: var(--gangl-padding-small);
    }
    &__image {
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
        position: relative;

        // === SKELETON
        // background: linear-gradient(
        //   90deg,
        //   rgba(#000, 0.065) 8%,
        //   rgba(#000, 0.135) 18%,
        //   rgba(#000, 0.065) 33%
        // );

        // background-size: 800px 104px;
        // animation-duration: 1s;
        // animation-fill-mode: forwards;
        // animation-iteration-count: infinite;
        // animation-name: shimmer;
        // animation-timing-function: linear;
    }
    &__spinner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
    }
    &__pdf {
        background-image: url("../assets/img/pdf_thumb.jpg");
        background-size: cover;
        background-position: center;
    }
    &__folder {
        overflow: hidden;
        // white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>

<style lang="scss">
.c-dokbox-card {
    .card-native,
    ion-grid,
    ion-row {
        height: 100%;
    }
}
</style>
